import PropTypes from 'prop-types'

const PageTitle = ({ pageTitle, subtitle }) => {
  return (
    <div className="font-avenir-heavy flex justify-between pb-4">
      <div className="flex justify-start">
        <div>
          <div className="type-header-1 max-tablet-p:type-header-2">{pageTitle}</div>
          {subtitle && <div className="font-avenir type-body-2 text-grey-30">{subtitle}</div>}
        </div>
      </div>
    </div>
  )
}

PageTitle.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  // Only the listing scoped to a data element says anything more than its title.
  subtitle: PropTypes.string,
}

export default PageTitle
